var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailIconDarkThemeFl = function SvgEmailIconDarkThemeFl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emailIcon_dark_theme_fl_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.99.5H1.01C.45.5 0 .95 0 1.51v9.99c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V1.51C16.01.95 15.56.5 15 .5h-.01ZM8 6.78 1.96 1.6h12.08L8 6.78Zm-2.08-.35L1.1 10.57V2.3l4.82 4.14v-.01Zm.84.73L8 8.23l1.24-1.07 4.95 4.25H1.8l4.95-4.25h.01Zm3.32-.73L14.9 2.3v8.27l-4.82-4.14Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emailIcon_dark_theme_fl_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h16v12H0z"
  })))));
};
export default SvgEmailIconDarkThemeFl;